export default {
  fetchedSurveys(state) {
    return state.surveys;
  },
  fetchedSelectSurvey(state) {
    return state.selectSurvey;
  },
  fetchedSurveyAnswerYn(state) {
    return state.surveyAnswerYn;
  },
  fetchedValidateYn(state) {
    return state.validateYn;
  },
  fetchedSurveyQuestions(state) {
    return state.surveyQuestions;
  },
  fetchedSelectGuestSurvey(state) {
    return state.selectGuestSurvey;
  },
};



// WEBPACK FOOTER //
// ./src/store/survey/getters.js